import { render, staticRenderFns } from "./LoyaltyCards.vue?vue&type=template&id=cde20024&scoped=true"
import script from "./LoyaltyCards.vue?vue&type=script&lang=js"
export * from "./LoyaltyCards.vue?vue&type=script&lang=js"
import style0 from "./LoyaltyCards.vue?vue&type=style&index=0&id=cde20024&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cde20024",
  null
  
)

export default component.exports